import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/Store';
import {
  selectUser,
  selectIsAuthenticated,
  selectAuthLoading,
  selectAuthError,
} from '../redux/selectors/authSelectors';
import {
  login as loginThunk,
  logout as logoutThunk,
  register as registerThunk,
  walletLogin as walletLoginThunk
} from '../redux/thunks/authThunks';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isLoading = useAppSelector(selectAuthLoading);
  const error = useAppSelector(selectAuthError);

  const login = useCallback(
    async (email: string, password: string) => {
      const result = await dispatch(loginThunk({ email, password }));
      return result;
    },
    [dispatch]
  );

  const register = useCallback(
    async (email: string, password: string) => {
      const result = await dispatch(registerThunk({ email, password }));
      return result;
    },
    [dispatch]
  );

  const logout = useCallback(async () => {
    await dispatch(logoutThunk());
  }, [dispatch]);

  const walletLogin = useCallback(
    async (walletAddress: string, signature: string, message: string) => {
      const result = await dispatch(walletLoginThunk({ walletAddress, signature, message }));
      return result;
    },
    [dispatch]
  );

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    register,
    logout,
    walletLogin,
  };
};
